// export const extractHostname = () => {
//       return window?.location?.hostname.replace(/(https?:\/\/)?(www\.)?/i, "").replace(/\/+/g, "");
// };

export const extractHostname = () => {
      // console.log("sss" ,window.location?.hostname === "localhost" )
      const URl = window.location?.hostname === "localhost" ? "thegrill.mypreview.xyz" :
            window?.location?.hostname.replace(/(https?:\/\/)?(www\.)?/i, "").replace(/\/+/g, "");
      return URl
};